module.exports = __webpack_public_path__ + "img/ic-exclamation-mark.aa5f673e.svg";